/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumb, Button, Input, message } from 'antd';
import { ReloadOutlined, MinusOutlined } from '@ant-design/icons';
import { changeUserStatus, deleteUser, getAllUsers } from '../../redux/userSlice';

import { style } from '../../Styles';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import DrawerUser from './DrawerUser';
import ActionButtonWithChangeStatus from '../Global/ActionButtonWithChangeStatus';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import CustomAvatar from '../Global/CustomAvatar/CustomAvatar';
import { getAllFleetOperators } from '../../redux/fleetOperatorSlice';
import { formatEnumValue } from '../../Utils/ArrayToObject';

const Users = () => {
	const columns = [
		{
			title: 'Profile Picture',
			key: 'profilePicture',
			render: (record) => {
				return record.profilePicture ? (
					<ImageComponent size={40} imageId={record?.profilePicture} />
				) : (
					<CustomAvatar name={`${record.name} ${record.surname}`} type='initials' />
				);
			},
			width: 150,
		},
		{
			title: 'Name',
			key: 'name',
			render: (record) => {
				return <span>{`${record.name} ${record.surname}`}</span>;
			},
			sorter: true,
		},
		{
			title: 'Email',
			dataIndex: 'email',
			sorter: true,
		},
		{
			title: 'Role',
			key: 'role',
			render: (record) => {
				return record.role?.length > 0 ? (
					<span>
						{record.role?.map((item) => {
							return (
								<span key={item} style={style.tags}>
									{formatEnumValue(item)}
								</span>
							);
						})}
					</span>
				) : (
					<MinusOutlined />
				);
			},
		},
		{
			title: 'Phone',
			key: 'phone',
			render: (record) => {
				return <span>{`+(${record.phoneCountryCode}) ${record.phone}`}</span>;
			},
		},
		{
			title: 'Country',
			key: 'country',
			render: (record) => {
				return (
					<span>{`${record.address || ''} ${record.state || ''} ${record.country || ''} ${record.zipCode || ''
						}`}</span>
				);
			},
			sorter: true,
		},
		{
			title: 'Status',
			key: 'active',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record.active ? (
							<div style={style.statusActif}>ACTIVE</div>
						) : (
							<div style={style.statusInactif}>INACTIVE</div>
						)}
					</span>
				);
			},
			sorter: true,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButtonWithChangeStatus
					record={record}
					onDelete={() => handleDeleteUser(record.id, () => { })}
					onRowClick={() => handleSelectedUser(record)}
					onChangeStatus={() => handleChangeStatus(record)}
				/>
			),
		},
	];

	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);

	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const { Users } = useSelector((state) => state.users);
	const [user, setUser] = useState(null);
	const [isMakingApiCall, setMakingApiCall] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('name');
	const [sortDirection, setSortDirection] = useState('ASC');
	const fetchAllFlletOperators = () => {
		dispatch(getAllFleetOperators())
			.unwrap()
			.then(() => { })
			.catch(() => {
				message.error('Error getting fleet operators');
			});
	};
	const fetchAllUsers = () => {
		setMakingApiCall(true);
		dispatch(getAllUsers({ page: currentPage - 1, size: pageSize, search, sortBy, sortDirection }))
			.then(() => { })
			.catch(() => { })
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('name');
			setSortDirection('ASC');
		}
		setCurrentPage(1);
	};

	useEffect(() => {
		fetchAllUsers();
		fetchAllFlletOperators();
	}, []);
	useEffect(() => {
		fetchAllUsers();
	}, [currentPage, pageSize, search, sortBy, sortDirection]);

	const handleChangeStatus = (record) => {
		setMakingApiCall(true);
		dispatch(
			changeUserStatus({
				userId: record.id,
				active: !record.active,
			}),
		)
			.unwrap()
			.then(() => {
				message.success('User status updated successfully');
			})
			.catch(() => {
				message.error('Error updating user status');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const handleDeleteUser = (id, callback) => {
		setMakingApiCall(true);
		dispatch(
			deleteUser({
				userId: id,
			}),
		)
			.unwrap()
			.then(() => {
				message.success('User deleted successfully');
				callback();
			})
			.catch(() => { })
			.finally(() => {
				onClose();
				setMakingApiCall(false);
			});
	};

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
		setUser(null);
	};

	const handleSelectedUser = (selectedUser) => {
		setUser(selectedUser);
		showDrawer();
	};

	let userArray = Object.values(Users.usersList);
	userArray = userArray.map((item) => {
		return { ...item, key: item.id };
	});
	return (
		<>
			<div style={style.inlineContent}>
				<div
					style={{
						display: 'flex',
						alignContent: 'center',
						alignItems: 'center',
						float: 'left',
						marginBottom: 8,
					}}>
					<Breadcrumb
						style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
						items={[
							{
								title: 'Users',
							},
						]}
					/>
					<Button
						type='default'
						size='small'
						// style={{ margin: '0 8px 8px 0' }}
						onClick={() => fetchAllUsers()}>
						<ReloadOutlined />
					</Button>
				</div>
				<div
					style={{
						...style.inlineContent,
						float: 'right',
						marginBottom: 8,
					}}>
					<Input.Search
						placeholder='Search'
						allowClear
						style={{ margin: '0 8px 8px 0' }}
					onSearch={(value) => { if (searchTimerRef.current) clearTimeout(searchTimerRef.current); setSearch(value); setCurrentPage(1); }}
					onChange={(e) => { const val = e.target.value; if (searchTimerRef.current) clearTimeout(searchTimerRef.current); searchTimerRef.current = setTimeout(() => { setSearch(val); setCurrentPage(1); }, 400); }}
					/>
					<Button
						type='default'
						style={{ float: 'right', marginBottom: 8 }}
						onClick={showDrawer}>
						Add User
					</Button>
				</div>
			</div>
			<CustomTableComponentsPageable
				isMakingApiCall={isMakingApiCall}
				columns={columns}
				dataArray={userArray}
				handleDoubleClickRow={(record) => handleSelectedUser(record)}
				handleSelectedRow={() => { }}
				onTableChange={handleTableChange}
				pagination={{
					current: currentPage,
					pageSize,
					total: Users?.total || 0,
					onChange: (page, size) => {
						setCurrentPage(page);
						setPageSize(size);
					},
				}}
			/>

			{open && (
				<DrawerUser
					onClose={onClose}
					open={open}
					userId={user?.id}
					handleDeleteUser={handleDeleteUser}
				/>
			)}
		</>
	);
};

export default Users;
